<template>
	<div>

		<!-- Ficha base -->
		<!--<FichaEstructura
			:class="[{'window-active': ventanas.length}]"
			:entidad="entidad"
			@openWindow="nuevaVentana"
			:active="ventanas.every(e => !e.isOpen)"/>-->

		<div class="screen">
			<!-- Pantalla principal -->
			<div class="screen-main">
				<FichaEstructura
					:class="[{'window-active': ventanas.length}]"
					:entidad="entidad"
					@openWindow="nuevaVentana"
					:active="ventanas.every(e => !e.isOpen)"/>
			</div>

			<!-- Pantalla dividida -->
			<div class="screen-division" v-if="screendivision">
				<FichaEstructura
					:key="screendivision.id"
					:id="screendivision.id"
					:entidad="screendivision.entidad"
					@openWindow="nuevaVentana"/>
			</div>
		</div>

		<!-- Ventanas -->
		<hsc-window-style-white>
			<hsc-window
				v-for="w of ventanas" 
				:key="w.id"
				:width="w.width"
				:height="w.height"
				:closeButton="false" 
				:isOpen.sync="w.isOpen"
				:left.sync="w.left"
      			:top.sync="w.top"
				@activate="activate(w)"
				:class="[{active: w.active}]"
				:style="{'z-index': w.active ? 999 : 100}">

				<div
					ref="handle"
					class="window-nav"
					@mousedown="mousedown($event, w)"
				>
					<span>{{w.type == 'iframe' ? w.code : `${w.title} ${w.code}`}}</span>
					<div class="window-nav-action">
						<i v-if="w.type !== 'iframe'" class="el-icon-refresh" @click="update(w)" title="actualizar"></i>
						<i class="el-icon-minus" @click="minimizar(w)" title="minimizar"></i>
						<i class="el-icon-news" @click="maximizar(w)" title="maximizar"></i>
						<i class="el-icon-close" @click="cerrar(w)" title="cerrar"></i>
					</div>
				</div>
				
				<div class="window-inner">
					<iframe
						v-if="w.type == 'iframe'"
						title="Inline Frame Example"
						width="100%"
						height="100%"
						frameborder="0"
						:src="w.url">
					</iframe>
					<PropuestaHistorica
						v-else-if="w.type == 'propuesta_historica'"
						:key="`propuesta_historica_${w.id}_${w.reloadKey || 0}`"
						:id="w.code"
					/>
					<ReservasBarco
						v-else-if="w.type == 'reserva_barco'"
						:key="`reserva_barco_${w.id}_${w.reloadKey || 0}`"
						:id="w.code"
					/>
					<FichaEstructura
						v-else
						:id="w.code"
						:entidad="w.entidad"
						:active="w.active"
						@openWindow="nuevaVentana"
						/>
				</div>

			</hsc-window>
		</hsc-window-style-white>

		<!-- Barra de ventanas minimizadas -->
		<div class="window-bar" v-if="ventanas.length">
			<ul>
				<li
					v-for="w of ventanas" 
					:key="w.id"
					@click="w.isOpen = !w.isOpen"
					:class="[{open: w.isOpen}, {active: w.active}]">
					{{`${w.title} ${w.code}`}}
				</li>
			</ul>
		</div>

	</div>
</template>

<script>
	import { mapMutations, mapState } from 'vuex'
	import FichaEstructura from '@/components/FichaEstructura.vue'
	import PropuestaHistorica from '@/views/PropuestaHistorica.vue'
	import ReservasBarco from '@/views/ReservasBarco.vue'

	export default {
		metaInfo() {
			return {
				title: this.entidad.toUpperCase()
			}	
		},
		name: 'Entidad',
		components: {
			FichaEstructura,
			PropuestaHistorica,
			ReservasBarco
		},
		props: {
			id: String,
			entidad: String
		},
		data() {
			return {
				ventanas: [],
				screendivision: null
			}
		},
		computed: {
			...mapState({
				fichas: state => state.ficha.data
			})
		},
		watch: {
			fichas: {
				handler() {
					
					let _self = this
					_self.fichas.forEach((ficha,i) => {
						if (ficha && ficha.title) {
							
							let ventana = _self.ventanas.find(f => f.code == ficha.id && f.entidad == ficha.entidad)
							if (ventana && ventana.title) {
								ventana.title = ficha.title
							}
						}
					})
				},
				deep: true
			}
		},
		methods: {
			...mapMutations([
				'delFicha',
				'setUpdateFicha'
			]),
			nuevaVentana(value) {

				// Pantalla dividida
				if(value.dividerScreen) {
					this.screendivision = {
						id: value.id,
						entidad: value.entidad
					}
					return
				}

				// Comprobar que ya este abierta (id y entidad)
				let identificador = value.titulo || `${value.entidad || this.entidad}_${value.id}`
				const ventanaExist = this.ventanas.find(f => f.id == identificador)
				
				if (ventanaExist) {

					this.activate(ventanaExist)
					ventanaExist.isOpen = true
					
					return
				}
				
				// Comprobar limite de ventanas abiertas
				if (this.ventanas.length >= 5) {
					this.$alert('Has llegado al limite de ventanas abiertas', 'Cierra alguna ventana', {
						confirmButtonText: 'Aceptar'
					})
					return
				}

				const entidadVentana = value.entidad || this.entidad || value.titulo
				const codeVentana = value.id || value.titulo

				let ventana = {
					isOpen: true,
					active: false,
					height: 800,
					left: 50,
					top: 50,
					code: codeVentana,
					id: value.titulo || `${value.entidad || this.entidad}_${value.id}`,
					entidad: entidadVentana,
					title: entidadVentana,
					type: value.openType ? 'iframe' : 'ficha',
					reloadKey: 0
				}

				// Propuesta histórica: renderizar el componente dentro de la ventana (sin iframe)
				if (entidadVentana === 'propuestas_pedido' && codeVentana != null && codeVentana !== '') {
					ventana.type = 'propuesta_historica'
				}
				if (entidadVentana === 'reservas_barco' && codeVentana != null && codeVentana !== '') {
					ventana.type = 'reserva_barco'
				}

				if (value.url) ventana.url = value.url

				this.ventanas.push(ventana)
			},
			mousedown(e, w) {
				
				const ventana = this.ventanas.find(f => f.id == w.id)

				const baseLeft = ventana.left
				const baseTop = ventana.top

				const mousemove = (e2) => {
					ventana.left = baseLeft + e2.screenX - e.screenX
					ventana.top = baseTop + e2.screenY - e.screenY
				}

				const mouseup = () => {
					document.removeEventListener('mousemove', mousemove)
					document.removeEventListener('mouseup', mouseup)
				}

				document.addEventListener('mousemove', mousemove)
				document.addEventListener('mouseup', mouseup)
			},

			// Eventos de ventana
			update(w) {
				if (w.type === 'propuesta_historica' || w.type === 'reserva_barco') {
					w.reloadKey = (Number(w.reloadKey) || 0) + 1
					return
				}
				this.setUpdateFicha(w.code, true)
			},
			minimizar(w) {
				w.isOpen = false
			},
			maximizar(w) {

				if(w.type == 'iframe') {

					this.openwindow(w.url,'_blank')

				} else {

					let url = ''

					if(window.distributionapp.publicPath) {
						
						url = `${window.location.origin}/${window.distributionapp.publicPath}#/${w.entidad}/${w.code}`
							
					} else {

						url = `${window.location.origin}#/${w.entidad}/${w.code}`
					}

					this.openwindow(`${url}`, '_blank')
				}
			},
			cerrar(w) {
				
				let ventanaIndex = this.ventanas.findIndex(f => f.id == w.id)
				this.ventanas.splice(ventanaIndex, 1)

				// No eliminar ficha en el store para la vista histórica embebida.
				// Evita que cerrar la ventana pequeña cierre también la pantalla completa.
				if (w.type !== 'iframe' && w.type !== 'propuesta_historica' && w.type !== 'reserva_barco') this.delFicha(w.code)
			},
			activate(w) {
				this.ventanas.forEach(f => f.active = false)
				w.active = true
			}
		}
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.window {
    background-color: white!important;
    border-radius: 4px!important;
	box-shadow: 0 10px 30px rgba(0,0,0,0.47), 0 1px 2px rgba(0,0,0,0.24)!important;
	width: 1200px;
	height: 600px!important;

	> .titlebar.draggable-handle {
		display: none!important;
	}
	
	&.active {
		.content .window-nav {
			background-color: $--color-window-header!important;
			color: white;
		}

	}

	.content {
		overflow: hidden;
		padding: 0px!important;

		.window-nav {
			background-color: #f2f2f2 !important;
			color: #6e6e6e;
			padding: 5px 10px;
			border-radius: 4px 4px 0px 0px;
			cursor: all-scroll!important;
			display: flex;
    		justify-content: space-between;
			align-items:center;
			border-bottom: 1px solid #e5e5e5;

			.window-nav-action {
				display: flex;
				align-items: center;

				i {
					cursor: pointer;
					margin-left: 10px;
					display: flex;
					align-items: center;
					padding: 3px 7px;
					&.el-icon-close {
						background-color: #ff8484;
						color: white;
						border-radius: 4px;
					}
				}
			}
		}

		.window-inner {
			height: calc((100% - 30px) - 20px);
			overflow: hidden;
			margin: 8px;
			border: 1px solid #e5e5e5;
			position: relative;
		}

		.page-element {
			height: 100%;
			overflow: hidden;
		}
	}

	@media (min-width: 992px) and (min-height: 750px) { height: 700px!important; }

	@media (min-width: 1200px) and (min-height: 900px) { height: 816px!important; }

}

// Estilo pantalla dividida
.screen {
	display: flex;
	height: 100vh;

	.screen-main {
		position: relative;
		flex-grow: 1;
	}

	.screen-division {
		width: 600px;
		height: 100vh;
		position: relative;
		border-left: 1px solid #ececec;
	}
}

.page-element {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
	background-color: #fafafa;

	&.window-active {
    	height: calc(100% - 42px)!important;
	}
}

.window-bar {
	background-color: white;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 5px;
    box-shadow: 0 -9px 15px -7px rgba(0, 0, 0, 0.09) !important;
	z-index: 9999;

	ul {
		list-style: none;
		padding: 0px 15px;
		margin: 0px;
		display: flex;
		align-items: center;

		li {
			padding: 5px 15px;
			font-size: 0.9rem;
			border: 1px solid #dbdbdb;
			margin-right: 5px;
			cursor: pointer;
			transition-duration: 200ms;

			&:hover {
				background-color: #edeff3
			}
			
			&.open {
				background-color: $--color-window-header; //#4a596aab
				color: white;
				&.active {
				background-color: $--color-window-header;
			}
			
				&:hover {
					background-color: #414c59;
				}
			}
			
		}
	}
}
</style>
